import type { WorkOrderResultData, WorkOrderChangeResultData, WorkOrderVersionResultData } from 'gql/graphql';

export const getFindKey = (item: WorkOrderResultData | WorkOrderChangeResultData | WorkOrderVersionResultData) =>
    item.section === null ? item.chapter : item.section;

export const getSeasonAccessor = (id: number): `season${string}Result` => `season${id}Result`;

export const getSummaryTableAdditionalClassName = ({ column, row }: any) =>
    [column?.accessor, row?.type?.toLowerCase()].join(' ');
